// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-container {
  height: 100vh;
  overflow-y: auto;
}
#main-container .header {
  background: #fff;
  margin-bottom: 10px;
}
#main-container .header .container-image {
  width: 40%;
  margin: auto;
  margin-bottom: 10px;
}
#main-container .header .container-image img {
  width: 100%;
  height: 80px;
}
#main-container .container-title {
  color: white;
  background-color: #294adb;
  display: flex;
  align-items: center;
  padding: 2% 5% 2% 5%;
  height: 130px;
  justify-content: space-between;
}
#main-container .container-title .container-icon-and-title {
  display: flex;
  align-items: center;
}
#main-container .container-title .container-icon-and-title h1 {
  font-weight: 400;
}
#main-container .container-title .container-button-enter button {
  display: flex;
  color: #294adb;
  background: white;
}
#main-container .container-title .container-button-enter button mat-icon {
  transform: scale(2);
  order: 1;
  margin-left: 10px;
}
#main-container .content {
  display: flex;
  justify-content: center;
  align-items: center;
}
#main-container .content .questions {
  width: 50%;
  margin-bottom: 20px;
}
#main-container .content .questions h3 {
  font-size: 20px;
  color: #637888;
  margin-bottom: 20px;
}
#main-container .content .questions p {
  color: black;
  line-height: 24px;
  font-weight: lighter;
  font-size: 15px;
}
#main-container .content .questions p .tag-email {
  text-decoration: underline;
  cursor: pointer;
  color: #294adb;
  font-size: 16px;
}

/* responsive desgin */
@media screen and (max-width: 768px) {
  .container-title {
    display: grid !important;
    justify-content: center !important;
    align-content: baseline !important;
    gap: 10px;
    padding: 0%;
  }
  .container-title h1 {
    font-size: 22px !important;
    margin-left: 5px;
  }
  .container-button-enter {
    text-align: center;
  }
  .content .questions {
    width: 90% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/component/frequently-questions/frequently-questions.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;AACJ;AACI;EACI,gBAAA;EACA,mBAAA;AACR;AACQ;EACI,UAAA;EACA,YAAA;EACA,mBAAA;AACZ;AACY;EACI,WAAA;EACA,YAAA;AAChB;AAII;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;AAFR;AAIQ;EACI,aAAA;EACA,mBAAA;AAFZ;AAGY;EACI,gBAAA;AADhB;AAMY;EACI,aAAA;EACA,cAAA;EACA,iBAAA;AAJhB;AAMgB;EACI,mBAAA;EACA,QAAA;EACA,iBAAA;AAJpB;AAUI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AARR;AAUQ;EACI,UAAA;EACA,mBAAA;AARZ;AASY;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AAPhB;AASY;EACI,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AAPhB;AASgB;EACI,0BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAPpB;;AAcA,sBAAA;AACA;EAEI;IACI,wBAAA;IACA,kCAAA;IACA,kCAAA;IACA,SAAA;IACA,WAAA;EAZN;EAcM;IACI,0BAAA;IACA,gBAAA;EAZV;EAgBE;IACI,kBAAA;EAdN;EAkBM;IACI,qBAAA;EAhBV;AACF","sourcesContent":["#main-container {\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n\r\n    .header {\r\n        background: #fff;\r\n        margin-bottom: 10px;\r\n\r\n        .container-image {\r\n            width: 40%;\r\n            margin: auto;\r\n            margin-bottom: 10px;\r\n\r\n            img {\r\n                width: 100%;\r\n                height: 80px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .container-title {\r\n        color: white;\r\n        background-color: #294adb;\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 2% 5% 2% 5%;\r\n        height: 130px;\r\n        justify-content: space-between;\r\n\r\n        .container-icon-and-title {\r\n            display: flex;\r\n            align-items: center;\r\n            h1 {\r\n                font-weight: 400;\r\n            }\r\n        }\r\n\r\n        .container-button-enter {\r\n            button {\r\n                display: flex;\r\n                color: #294adb;\r\n                background: white;\r\n\r\n                mat-icon {\r\n                    transform: scale(2);\r\n                    order: 1;\r\n                    margin-left: 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .content {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .questions {\r\n            width: 50%;\r\n            margin-bottom: 20px;\r\n            h3 {\r\n                font-size: 20px;\r\n                color: #637888;\r\n                margin-bottom: 20px;\r\n            }\r\n            p {\r\n                color: black;\r\n                line-height: 24px;\r\n                font-weight: lighter;\r\n                font-size: 15px;\r\n\r\n                .tag-email {\r\n                    text-decoration: underline;\r\n                    cursor: pointer;\r\n                    color: #294adb;\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* responsive desgin */\r\n@media screen and (max-width: 768px) {\r\n\r\n    .container-title {\r\n        display: grid !important;\r\n        justify-content: center !important;\r\n        align-content: baseline !important;\r\n        gap: 10px;\r\n        padding: 0%;\r\n\r\n        h1 {\r\n            font-size: 22px !important;\r\n            margin-left: 5px;\r\n        }\r\n    }\r\n\r\n    .container-button-enter {\r\n        text-align: center;\r\n    }\r\n\r\n    .content {\r\n        .questions {\r\n            width: 90% !important;\r\n        }\r\n\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
